import { createContext } from 'react';

import { UserTypes } from './UserTypes.ts';

export type ExternalShareContextType = {
	isExternalShareRequest: boolean;
	userType: UserTypes;
	shareToken?: string;
	isShareableLinkRequest: boolean;
};

export const ExternalShareContext = createContext<ExternalShareContextType>({
	isExternalShareRequest: false,
	userType: UserTypes.ANONYMOUS,
	shareToken: undefined,
	isShareableLinkRequest: false,
});
